/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from "react";
import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
import { ShimmerTitle } from 'react-shimmer-effects'

const DropDownComponent = ({
    placeHolder,
    id,
    divClassName,
    options,
    handleOnchangeInput,
    value,
    dropDownName,
    index,
    buttonDisabled,
    showErrorBorder,
    listWidth,
    dropdownId,
    test_id,
    SameName,
    optionsKey,
    loading,
    applyBGForDisabled
}) => {
    const [isOpen, setisOpen] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const optionsRef = useRef([]);

    useOnClickOutside(ref, () => {
        setisOpen(false);
        setFocusedIndex(-1);
    });

    const calculateDropdownPosition = () => {
        if (buttonRef.current && dropdownRef.current) {
            const buttonRect = buttonRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - buttonRect.bottom - 40;
            const dropdownHeight = dropdownRef.current.clientHeight;

            if (spaceBelow < dropdownHeight) {
                dropdownRef.current.style.top = `-${dropdownHeight}px`;
            } else {
                dropdownRef.current.style.top = '100%';
            }
        }
    };

    useEffect(() => {
        if (isOpen) {
            window.addEventListener('resize', calculateDropdownPosition);
            calculateDropdownPosition();
            return () => {
                window.removeEventListener('resize', calculateDropdownPosition);
            };
        }
    }, [isOpen]);

    useEffect(() => {
        if (focusedIndex !== -1 && optionsRef.current[focusedIndex]) {
            optionsRef.current[focusedIndex].scrollIntoView({
                block: 'nearest',
            });
        }
    }, [focusedIndex]);

    const handleKeyDown = (e) => {
        if ((e.key === 'Enter' || e.key === 'Return') && !isOpen) {
            e.preventDefault();
            setisOpen(true);
            setTimeout(() => dropdownRef.current?.focus(), 0);
        } else if (e.key === 'Escape' || e.key === 'Tab') {
            setisOpen(false);
            setFocusedIndex(-1);
        }
    };

    const handleListKeyDown = (e) => {
        e.stopPropagation();
        if (e.key === 'Escape' || e.key === 'Tab') {
            setisOpen(false);
            setFocusedIndex(-1);
            buttonRef.current.focus();
            return;
        }

        if (options?.length > 0) {
            switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    (prevIndex < options.length - 1 ? prevIndex + 1 : 0)
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    (prevIndex > 0 ? prevIndex - 1 : options.length - 1)
                );
                break;
            case 'Enter':
            case 'Return':
                e.preventDefault();
                if (focusedIndex !== -1) {
                    handleOnchangeInput(dropDownName, options[focusedIndex], index);
                    setisOpen(false);
                    setFocusedIndex(-1);
                    buttonRef.current.focus();
                } else {
                    setisOpen(false);
                    setFocusedIndex(-1);
                    buttonRef.current.focus();
                }
                break;
            default:
                break;
            }
        } else if (e.key === 'Enter' || e.key === 'Return') {
            e.preventDefault();
            setisOpen(false);
            setFocusedIndex(-1);
            buttonRef.current.focus();
        }
    };

    const handleOptionClick = (option) => {
        handleOnchangeInput(dropDownName, option, index);
        setisOpen(false);
        setFocusedIndex(-1);
    };

    return (
        <div className={divClassName} data-te-dropdown-ref id={id} ref={ref}>
            <button
                ref={buttonRef}
                disabled={buttonDisabled !== undefined && buttonDisabled}
                title={value}
                onClick={() => {
                    const isOpening = !isOpen;
                    setisOpen(isOpening);
                    if (isOpening) {
                        setTimeout(() => dropdownRef.current?.focus(), 0);
                    }
                }}
                onKeyDown={handleKeyDown}
                className={`slct-inpt-fld transition duration-150 ease-in-out  ${showErrorBorder ? 'redBorder' : ''} 
                ${buttonDisabled && applyBGForDisabled ? 'bg-[#E6E8EA]' : 'bg-white'}`}
                type="button"
                id={dropDownName}
                data-testid={test_id}
                data-te-dropdown-toggle-ref
                aria-expanded="false"
            >
                <p
                    className={`text-f7 ${
                        (value === "" || value === undefined || value === true)
                            ? "text-[#818E98]"
                            : "text-[#031624]"
                    } font-normal `}
                >
                    {(value === "" || value === undefined || value === true)
                        ? placeHolder
                        : value}
                </p>
                <img
                    src="/images/dropdown-icon.png"
                    alt="icon"
                    className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${
                        isOpen ? "transform rotate-180" : ""
                    }`}
                />
            </button>
            <ul
                ref={dropdownRef}
                tabIndex="-1"
                onKeyDown={handleListKeyDown}
                style={{ outline: 'none' }}
                className={`slct_drp_dwn ${listWidth !== undefined ? `w-[${listWidth}]` : 'min-w-full'} ${
                    isOpen ? "" : "hidden"
                } [&[data-te-dropdown-show]]:block `}
                aria-labelledby="dropdownMenu_acdemic_year"
                data-te-dropdown-menu-ref
                title={value}
            >
                <li className="max-h-[220px] overflow-auto scroll-bar">
                    <ul>
                        {
                            loading ? (
                                <p className="text-2xl font-bold text-[#031624] mb-4 mt-4 px-2"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                            ) : (
                                options?.length > 0 ? (
                                    options.map((option, i = 0) => (
                                        <li
                                            key={i}
                                            ref={el => { optionsRef.current[i] = el; }}
                                            className={`${focusedIndex === i ? 'bg-gray-100' : ''}`}
                                            id={dropdownId === undefined ? dropDownName : SameName === undefined ? `${dropDownName}_${i}` : optionsKey === undefined ? option.name : option[optionsKey]}
                                            onClick={() => handleOptionClick(option)}
                                        >
                                            <a
                                                title={optionsKey === undefined ? option.name : option[optionsKey]}
                                                className="slct_drp_dwn_optn"
                                                style={{ display: 'flex', alignItems: 'center' }}
                                            >
                                                {(optionsKey === undefined ? option.name : option[optionsKey]) === value
                                                    ? <img src="/images/bluedot.svg" alt="selected" className="mr-2 shrink-0" />
                                                    : <div className="w-[7px] h-[6px] mr-2 shrink-0"></div>
                                                }
                                                <span>{optionsKey === undefined ? option.name : option[optionsKey]}</span>
                                            </a>
                                        </li>
                                    ))
                                ) : (
                                    <li
                                        key=""
                                        id="select-option"
                                        onClick={() => {
                                            setisOpen(false);
                                        }}
                                    >
                                        <a className="slct_drp_dwn_optn">
                                            - No options available -
                                        </a>
                                    </li>))
                        }
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default DropDownComponent;
